import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import ToggleButton from '~shared/components/toggle-button/ToggleButton.jsx';
import {
    useAcceptOddsFlag,
    useIsUserLoggedIn,
} from '~SpectateStore/hooks/userHooks';
import {
    updateAcceptOddsFlag,
} from './utils';

import './styles.scss';

const AcceptOddsChanges = ({ source }) => {
    const [ t ] = useTranslation();

    const acceptOddsFlag = useAcceptOddsFlag();
    const isLoggedIn = useIsUserLoggedIn();

    if (!isLoggedIn) {
        return null;
    }

    const gtmEnd = acceptOddsFlag ? 'accept-odds-movement-off' : 'accept-odds-movement-on';
    const acceptOddsGtm = `${source};accept-odds-switcher;${gtmEnd}`;

    return (
        <div className="fullslip__oddsChanges">
            <ToggleButton
                toggleText={t('betslip.accept_odds')}
                isToggleOn={acceptOddsFlag}
                gtmAttribute={acceptOddsGtm}
                setToggleState={updateAcceptOddsFlag}
            />
        </div>
    );
};

AcceptOddsChanges.propTypes = {
    source: PropTypes.string.isRequired,
};

export default AcceptOddsChanges;
